



















































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import { upload } from '../../common/util/ossUploadService';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { yun, Anomaly, MinIO } from '@/http';
import ElImageViewer from '@/components/imageviewer.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        ElImageViewer,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
    },
})
export default class errorManager extends Vue {
    public stateType = enums.stateType;
    public errorEnum = enums.errorEnum;
    public errorformEnum = enums.errorformEnum;
    public auditStatusEnum = enums.auditEnum;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public dialogVisibles = false;
    public auditComment: any = '';
    public detailData: any = {};
    public handleClose() {
        this.dialogVisible = false;
    }
    public handleCloses() {
        this.dialogVisibles = false;
    }
    public customerComplaintWeightUnit = '';
    public customerComplaintWeightPriceUnit = '';
    public customerComplaintCutPaymentUnit = '';
    public searchValue: any = {
        carrierOrderCode: '',
        subOrderNo: '',
        shipOrderNo: '',
        relatedShipOrderNo: '',
        deliveryOrderNo: '',
        customerBaseId: '',
        carrierId: '',
        source: '',
        anomalyTypeEnum: '',
        auditStatus: '',
        startTime: '',
        endTime: '',
        enabled: true,
        orderBy: '',
        asc: true,
        realDeliveryStartTime: '',
        realDeliveryEndTime: '',
    };
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return;
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }

    public timeList = [];
    public timeList1 = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.startTime = value[0];
            this.searchValue.endTime = value[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    public datetimerange1(value) {
        if (value) {
            this.searchValue.realDeliveryStartTime = value[0];
            this.searchValue.realDeliveryEndTime = value[1];
        } else {
            this.searchValue.realDeliveryStartTime = null;
            this.searchValue.realDeliveryEndTime = null;
        }
    }
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('errorManager', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('errorManager'))
        ? JSON.parse(localStorage.getItem('errorManager'))
        : [
              { title: '序号', isShow: true, disabled: false },
              { title: '异常编号', isShow: true, disabled: false },
              { title: '审核状态', isShow: true, disabled: false },
              { title: '运单编号', isShow: true, disabled: false },
              { title: '子单号', isShow: true, disabled: false },
              { title: '装运单号', isShow: true, disabled: false },
              { title: '原装运单号', isShow: true, disabled: false },
              { title: '交货单号', isShow: true, disabled: false },
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '车队', isShow: true, disabled: false },
              { title: '异常来源', isShow: true, disabled: false },
              { title: '异常描述', isShow: true, disabled: false },
              { title: '异常类型', isShow: true, disabled: false },
              { title: '客诉重量', isShow: true, disabled: false },
              { title: '客诉单价', isShow: true, disabled: false },
              { title: '客诉扣款', isShow: true, disabled: false },
              { title: '反馈人', isShow: true, disabled: false },
              { title: '反馈时间', isShow: true, disabled: false },
          ];

    public labelPosition: string = 'right';
    public getAnomalyColor(val) {
        switch (val) {
            case '异常':
                return 'c_red';
            case '已撤销':
                return 'c_gray';

            default:
                break;
        }
    }
    public $refs!: {
        pagination: HTMLFormElement;
        pagination1: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        upload: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };

    public searchFunc() {
        // console.log('timeList1' + JSON.stringify(this.timeList1));
        this.searchValue.realDeliveryStartTime = this.timeList[0];
        this.searchValue.realDeliveryEndTime = this.timeList[1];
        this.isFirst = false;
        this.loadData();
        sessionStorage.setItem('errorManager_searchValue', JSON.stringify(this.searchValue));
    }
    public resetSearchValue() {
        this.searchValue = {
            carrierOrderCode: '',
            subOrderNo: '',
            shipOrderNo: '',
            relatedShipOrderNo: '',
            deliveryOrderNo: '',
            customerBaseId: '',
            carrierId: '',
            source: '',
            anomalyTypeEnum: '',
            auditStatus: '',
            startTime: '',
            endTime: '',
            enabled: true,
            orderBy: '',
            asc: true,
        };
        this.timeList = [];
        this.timeList1 = [];
        this.searchFunc();
    }
    public customerBaseIds = [];
    public carrierIds = [];
    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public rePagin1 = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;

    public tableData: any = [];

    public isFirst = true;
    public async loadData() {
        this.loading = true;
        let qualityAccidentIdList = null;
        if (this.$route.query.form == 'DataAnalysis' && this.isFirst) {
            let res: any = this.$route.query.qualityAccidentIdList;
            qualityAccidentIdList = JSON.parse(res);
        }
        try {
            let res = await Anomaly.GetAnomalyList({
                ...this.searchValue,
                qualityAccidentIdList: qualityAccidentIdList,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }
    public searchPagin1: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public qualityAccidentIdList: any = [];
    public ycglzk3: boolean = false;
    public ycglsh3: boolean = false;
    public ycglsc3: boolean = false;
    public ycbbdc3: boolean = false
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        console.log('webMenus', webMenus)
        this.ycglzk3 = webMenus.includes('ycglzk3');
        this.ycglsh3 = webMenus.includes('ycglsh3');
        this.ycglsc3 = webMenus.includes('ycglsc3');
        this.ycbbdc3 = webMenus.includes('ycbbdc3');
    }
    public anomalyTypeList: any = [];
    public vehicleTypeList: any = [];
    public async getdd() {
        this.anomalyTypeList = await yun.GetDicList({ typeName: 'anomalyType' });
        console.log(this.anomalyTypeList, 'this.anomalyTypeList');
    }
    // public async getshipperId(){
    //     let result = await Anomaly.GetDropDownList();
    //     result.forEach((item)=>{
    //         this.shipperIds.push({
    //             label:item.shipperName,
    //             value: item.shipperName,
    //         })
    //     })
    // }
    // public async getcarrierId(){
    //     let result = await Anomaly.GetCarrierList();
    //     result.data.forEach((item)=>{
    //         this.carrierIds.push({
    //             label:item.name,
    //             value: item.name,
    //         })
    //     })

    // }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        this.getdd();
        // this.getshipperId();
        // this.getcarrierId();
        if (sessionStorage.getItem('errorManager_searchValue') && this.$route.query.form != 'DataAnalysis') {
            this.searchValue = JSON.parse(sessionStorage.getItem('errorManager_searchValue'));
            this.searchPagin = sessionStorage.getItem('errorManager_page')
                ? JSON.parse(sessionStorage.getItem('errorManager_page'))
                : this.searchPagin;
            if (this.searchValue.startTime) {
                this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
                this.timeList1 = [this.searchValue.realDeliveryStartTime, this.searchValue.realDeliveryEndTime];
            }
            this.loadData();
        } else if (!sessionStorage.getItem('errorManager_searchValue') && this.$route.query.form != 'DataAnalysis') {
            this.searchPagin = sessionStorage.getItem('errorManager_page')
                ? JSON.parse(sessionStorage.getItem('errorManager_page'))
                : this.searchPagin;
            this.loadData();
        } else {
            if (this.$route.query.form == 'DataAnalysis') {
                let temp: any = this.$route.query.qualityAccidentIdList;
                this.qualityAccidentIdList = JSON.parse(temp);
                this.searchValue.arrivalAddress = this.$route.query.arrivalProvinceStr;
                this.searchValue.originAddress = this.$route.query.originProvinceStr;
                this.timeList = [this.$route.query.realDeliveryStartTimestr, this.$route.query.realDeliveryEndTimestr];
                this.searchValue.realDeliveryStartTime = this.timeList[0];
                this.searchValue.realDeliveryEndTime = this.timeList[1];
                this.searchValue.anomalyTypeEnum = 5;
                this.loadData();
            }
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('errorManager_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: any = {
        id: '',
        anomalyCode: '',
        carrierOrderCode: '',
        sourceStr: '',
        anomalyTypeEnum: '',
        auditStatus: '',
        anomalyTypeStr: '',
        description: '',
        cause: '',
        customerComplaintWeight: '',
        customerComplaintPrice: '',
        customerComplaintCutPayment: '',
        anomalyPictures: [],
        isOnlySave: true,
    };
    drivingLicenseImgs: any = [];
    roadTransportCertificateImgs: any = [];
    businessLicenseImgs: any = [];
    public title = '';
    // 发货方发生改变
    // public shipperid = '';
    // public async shipperIdChange(val){
    //      let result = await Anomaly.GetDropDownList();
    //      this.searchValue.shipperId = result.filter((item)=>item.shipperName===val)[0].id;
    //      console.log(this.searchValue.shipperId,'this.searchValue.shipperId');
    // }
    public restaurants = [];
    async querySearchAsyncSh(queryString, cb) {
        let res = await Anomaly.GetDropDownList({
            name: this.searchValue.customerBaseName,
        });
        this.restaurants = [];
        if (res) {
            res.forEach((item) => {
                this.restaurants.push({
                    id: item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.restaurants);
        }
    }
    async handleSelectSh(item, index) {
        this.searchValue.customerBaseId = item.id;
    }
    public restaurantCd = [];
    async querySearchAsyncCd(queryString, cb) {
        let res = await Anomaly.GetCarrierList({
            name: this.searchValue.carrierName,
            count: 30,
        });
        this.restaurantCd = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurantCd.push({
                    id: item.id,
                    value: item.name,
                    name: item.contactName,
                });
            });
            cb(this.restaurantCd);
        }
    }
    async handleSelectCd(item, index) {
        this.searchValue.carrierId = item.id;
    }
    // 车队发生改变
    // public carrierid = '';
    // public async carrierIdChange(val){
    //      let result = await Anomaly.GetCarrierList();
    //      this.searchValue.carrierId = result.data.filter((item)=>item.name===val)[0].id;
    //      console.log(this.searchValue.carrierId,'this.searchValue.carrierId');
    // }
    public save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                this.formData.isOnlySave = true;
                // this.formData.anomalyPictures = this.shipperAttachmentList;
                this.anomalyTypeList.forEach((e) => {
                    if (e.value === this.formData.anomalyTypeEnum) {
                        this.formData.anomalyTypeStr = e.name;
                    }
                });
                if (this.title == '编辑异常') {
                    let res = await Anomaly.AnomalyUpdate(this.formData);
                    this.$message.success('编辑成功');
                    this.loadData();
                } else {
                    this.formData.isAudit = true;
                    if (this.formData.isAudit) {
                        let res = await Anomaly.AnomalyUpdate({...this.formData,auditComment:this.auditComment});
                    }
                    this.$message.success('审核通过');
                    this.loadData();
                }
                this.dialogVisible = false;
            }
        });
    }
    // 自动计算客诉扣款
    public getSum() {
        if (this.formData.customerComplaintWeight && this.formData.customerComplaintPrice) {
            let total = this.formData.customerComplaintWeight * this.formData.customerComplaintPrice;
            total.toString().replace(/[^-\d^\.]+/g, '');
            if (!isNaN(total)) {
                this.formData.customerComplaintCutPayment = total.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
            } else {
                this.formData.customerComplaintCutPayment = '';
            }
            // this.formData.customerComplaintCutPayment =total.toString().match(/\d{1,9}(\.\d{0,2})?/) ? total.toString().match(/\d{1,9}(\.\d{0,2})?/)[0]:''
        } else {
            this.formData.customerComplaintCutPayment = '';
        }
    }
    weightChange(e, number) {
        if (number) {
            e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
            this.formData.customerComplaintWeight = e.target.value;
        } else {
            this.formData.customerComplaintWeight = e.target.value;
        }
    }
    priceChange(e, number) {
        if (number) {
            // e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
            // this.formData.customerComplaintPrice = e.target.value;
            e.target.value = e.target.value.replace(/[^-\d^\.]+/g, '');
            this.formData.customerComplaintPrice = e.target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        } else {
            this.formData.customerComplaintPrice = e.target.value;
        }
    }

    public async toView(data) {
        this.title = '查看异常';
        this.formData = {
            id: '',
            anomalyCode: '',
            carrierOrderCode: '',
            sourceStr: '',
            anomalyTypeEnum: '',
            auditStatus: '',
            anomalyTypeStr: '',
            description: '',
            cause: '',
            customerComplaintWeight: '',
            customerComplaintPrice: '',
            customerComplaintCutPayment: '',
            anomalyPictures: [],
            isOnlySave: true,
        };
        let res = await Anomaly.AnomalyGetDetail(data.id);
        if (res.anomalyPictures.length > 9) {
            this.hideUpload = true;
        } else {
            this.hideUpload = false;
        }
        Object.keys(res).forEach((key) => {
            this.formData[key] = res[key];
        });
        // console.log('this.formData.anomalyPictures.length============', JSON.stringify(this.formData.anomalyPictures));
        this.shipperAttachmentList = [];
        if (this.formData.anomalyPictures) {
            this.formData.anomalyPictures.forEach((data) => {
                this.shipperAttachmentList.push({
                    name: data.attachmentName,
                    url: data.attachmentPath,
                    uid: data.attachmentId,
                });
            });
        }
        this.formData.anomalyTypeEnum = Number(this.formData.anomalyTypeEnum);
        // this.$refs.formData.resetFields();
        this.dialogVisibles = true;
    }

    public async toEdit(data) {
        this.title = data.auditStatusStr === '待审核' ? '审核异常' : '编辑异常';
        this.formData = {
            id: '',
            anomalyCode: '',
            carrierOrderCode: '',
            sourceStr: '',
            anomalyTypeEnum: '',
            auditStatus: '',
            anomalyTypeStr: '',
            description: '',
            cause: '',
            customerComplaintWeight: '',
            customerComplaintPrice: '',
            customerComplaintCutPayment: '',
            anomalyPictures: [],
            isOnlySave: true,
        };
        this.auditComment = ''
        let res = await Anomaly.AnomalyGetDetail(data.id);
        if (res.anomalyPictures.length > 9) {
            this.hideUpload = true;
        } else {
            this.hideUpload = false;
        }
        Object.keys(res).forEach((key) => {
            this.formData[key] = res[key];
        });
        // console.log('this.formData.anomalyPictures.length============', JSON.stringify(this.formData.anomalyPictures));
        this.shipperAttachmentList = [];
        if (this.formData.anomalyPictures) {
            this.formData.anomalyPictures.forEach((data) => {
                this.shipperAttachmentList.push({
                    name: data.attachmentName,
                    url: data.attachmentPath,
                    uid: data.attachmentId,
                });
            });
        }
        this.formData.anomalyTypeEnum = Number(this.formData.anomalyTypeEnum);
        // this.$refs.formData.resetFields();
        this.dialogVisible = true;
    }

    public dialogConfig: any = {
        title: '',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    public btt: any = 0;
    async confirmOk() {
        // this.ssdata.isOnlySave = false;
        // Anomaly.AnomalyUpdate(this.ssdata).then(() => {
        //     this.$message.success('删除成功');
        //     this.dialogVisible = false;
        //     this.loadData();
        // });
        Anomaly.AnomalyDelete(this.ssdata.id).then(() => {
            this.$message.success('删除成功');
            this.dialogVisible = false;
            this.loadData();
        });
        this.dialogConfig = {
            show: false,
        };
    }
    public ssdata: any = {};
    public toDel(data) {
        this.btt = 3;
        this.ssdata = {};
        this.ssdata = data;
        this.dialogConfig = {
            title: '删除异常',
            show: true,
        };
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    public carTypeChange(item) {
        // console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData.carType = data.name;
        });
    }

    public async exportExcel() {
        if (this.$route.query.form == 'DataAnalysis' && this.isFirst) {
            let qualityAccidentIdList = null;
            let res: any = this.$route.query.qualityAccidentIdList;
            qualityAccidentIdList = JSON.parse(res);
            let data = await Anomaly.AnomalyListExport({
                qualityAccidentIdList: qualityAccidentIdList,
                ...this.searchValue,
            });
        } else {
            let data = await Anomaly.AnomalyListExport({
                ...this.searchValue,
            });
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'feedBackTime':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
        }
        this.loadData();
    }

    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    toDetail1(row, type, index) {
        // let bd = row.orderIdList.length > 1 ? true : false;
        if (type == 1) {
            console.log(row, 'row~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    // id: row.orderIdList[0],
                    name: 'detail',
                    // orderCnt: row.orderIdList.length,
                    orderId: row.carrierOrderId,
                    tab: 'second',
                    type: 'error',
                },
            });
        }
        // else if (type == 2) {
        //     this.$router.push({
        //         path: '/orderDetailcc',
        //         query: {
        //             id: row.orderList[index].id,
        //             name: 'detail',
        //             from: 'WayBillManage',
        //             carrierStatus: row.carrierOrderStatus,
        //         },
        //     });
        // } else if (type == 3) {
        //     this.$router.push({
        //         path: '/WayBillDetail',
        //         query: {
        //             id: row.orderList[0].id,
        //             name: 'detail',
        //             orderCnt: row.orderList.length,
        //             orderId: row.id,
        //             tab: 'third',
        //             carrierStatus: row.carrierOrderStatus,
        //         },
        //     });
        // }
    }
    async toDetail(id) {
        this.title = '查看异常';
        this.formData = {
            id: '',
            anomalyCode: '',
            carrierOrderCode: '',
            sourceStr: '',
            anomalyTypeEnum: '',
            auditStatus: '',
            anomalyTypeStr: '',
            description: '',
            cause: '',
            customerComplaintWeight: '',
            customerComplaintPrice: '',
            customerComplaintCutPayment: '',
            anomalyPictures: [],
            isOnlySave: true,
        };
        let res = await Anomaly.AnomalyGetDetail(id);
        Object.keys(res).forEach((key) => {
            this.formData[key] = res[key];
        });
        this.formData.anomalyTypeEnum = Number(this.formData.anomalyTypeEnum);
        // this.$refs.formData.resetFields();
        this.dialogVisibles = true;
    }
    selectCar2(data) {
        this.searchValue.carrierId = data.id;
    }
    selectList;
    carrierName: any = '';
    async querySearch2(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        // console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    /**
     * 图片上传
     */
    public shipperAttachmentList: any = [];
    public limitCount = 10;
    public showViewer: any = false;
    closeViewer() {
        this.showViewer = false;
    }
    dialogImageUrl = '';
    dialogImage: any = false;
    public handlePreview(file, type) {
        this.dialogImageUrl = file.url ? file.url : file.attachmentPath;
        this.dialogImage = true;
        if (type) {
            this.dialogImageUrl = file.url ? file.url : file.attachmentPath;
            this.dialogImage = true;
        }
    }
    public onClose() {
        this.dialogImage = false;
    }
    cc;
    store;
    public hideUpload: boolean = false;
    public canUpload: boolean = false;
    async handleUpload(param, data) {
        if (!this.isSend) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            this.cc = data;
            upload(param.file, param.file.name)
                .then((res) => {
                    if (res.res.statusCode == '200') {
                        let url = res.res.requestUrls[0].split('?')[0];
                        this.formData.anomalyPictures.push({
                            attachmentName: res.name,
                            attachmentPath: url,
                        });
                        loading.close();
                    } else {
                        this.$message.warning('图片上传失败!');
                    }
                })
                .catch((err) => {
                    loading.close();
                });
        }
    }
    public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$message.error('不支持该文件类型');
            return false;
        }
    }
    public loadProgress: any = 0;
    public isSend: boolean = false;
    async handleChange(file, fileList) {
        console.log(file, fileList, 'fileList');
        var theFile = file.raw;
        let size = theFile.size / 1024;
        if (size > 51200) {
            this.isSend = true;
            this.$refs.upload.clearFiles();
            this.$message.error('文件大小不超过50M');
            return false;
        } else {
            this.isSend = false;
        }
        this.hideUpload = fileList.length >= this.limitCount;
    }
    handleRemove(param, data) {
        this.formData.anomalyPictures = this.formData.anomalyPictures.filter((v) => {
            return v.attachmentPath !== param.url;
        });
        this.hideUpload = false;
    }
    getShowData(data) {
        let list = data.split(',');
        return list;
    }
}
